export enum InventoryTypeEnum {
  Refurb = "refurb",
  Outbound = "outbound",
  Dispatch = "dispatch",
}

export const InventoryTypesList = [
  { value: InventoryTypeEnum.Refurb, label: "Refurb inventory" },
  { value: InventoryTypeEnum.Outbound, label: "Outbound inventory" },
  { value: InventoryTypeEnum.Dispatch, label: "Dispatch inventory" },
];
